import React, { Component, Fragment } from 'react';
import I18n from '~/utils/translations';
import SVG from 'react-inlinesvg';
import houseIcon from 'images/benefit-icon-search.svg';

const NoResults = () => (
  <div className="no-results">
    <SVG className="no-results__icon" src={houseIcon} />
    <h4 className="no-results__text">{I18n.t('pages.homes.no_results')}</h4>
  </div>
);

export default NoResults;
